const initialState = {
    myRequests: [],
    requestsFromManager: [],
    allRequests: []
}

const requestResourceAvailabilityReducer = (state = initialState, action) => {
    switch(action.type) {
        case 'GET_MY_REQUESTS':
            return {
                ...state,
                myRequests: action?.payload
            }
        case 'GET_ALL_REQUESTS':
            return {
                ...state,
                allRequests: action?.payload
            }
        case 'GET_MANAGER_REQUESTS':
            return {
                ...state,
                requestsFromManager: action?.payload
            }
        default:
            return {...state}
    }
}

export default requestResourceAvailabilityReducer;